function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#374051;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 28.1,
  height: 28.1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4185",
  "data-name": "Group 4185"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4184",
  "data-name": "Group 4184"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6342",
  "data-name": "Path 6342",
  className: "cls-3",
  d: "M14.05,0A14.05,14.05,0,1,0,28.1,14.05a14,14,0,0,0-14-14m0,26.34A12.29,12.29,0,1,1,26.34,14.05,12.29,12.29,0,0,1,14.05,26.34M12.13,9.14h-3V19.83a.88.88,0,1,1-1.75,0h0V8.27a.87.87,0,0,1,.88-.88h3.86a4.74,4.74,0,0,1,4.74,4.74V16a.87.87,0,0,1-.88.87h0A.88.88,0,0,1,15.1,16l0-3.83a3,3,0,0,0-3-3m8.58-.87V19.83a.87.87,0,0,1-.88.88H16A4.74,4.74,0,0,1,11.23,16V12.13a.88.88,0,1,1,1.75,0V16a3,3,0,0,0,3,3h3V8.27a.88.88,0,1,1,1.76,0"
}))))));

function SvgPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.1 28.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.5850deb1.svg";
export { ForwardRef as ReactComponent };